module.exports = __webpack_public_path__ + "static/media/04_Testimonial.a22113ab.jpg";